import { getConfig } from '../../../store/slice/config/config';
import store from '../../../store/store';
import { handleAuthorizationCallback } from '../../auth-callback';
import { getConfigFromLocalStorage } from '../../local-storage';

let configPromise: Promise<unknown> | null = null;

export const rootLoader = async () => {
  // If the AuthProvider redirected the user back here with `?code=...`,
  // complete the PKCE token exchange before doing anything else.
  // (This covers the case when the registered redirect_uri is `/` rather
  //  than the dedicated `/auth/callback`.)
  await handleAuthorizationCallback();

  if (!getConfigFromLocalStorage()) {
    if (!configPromise) {
      configPromise = store.dispatch(getConfig());
    }

    await configPromise;
  }

  return true;
};
